// Selects mock vs. real HTTP API based on VITE_USE_MOCK_API.
// Default = real backend (mock only when VITE_USE_MOCK_API=true).
// To use the in-app mock: set VITE_USE_MOCK_API=true.

import type { ConsultationManualApi } from '../types/counseling-manual.types';
import { counselingManualHttpApi } from './counseling-manual.api';
import { counselingManualMockApi } from './counseling-manual.mock';

const useMock = import.meta.env.VITE_USE_MOCK_API === 'true';

export const counselingManualApi: ConsultationManualApi = useMock
  ? counselingManualMockApi
  : counselingManualHttpApi;
